import type { SVGProps } from 'react'

export function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    />
  )
}

export function SunIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <circle cx="12" cy="12" r="4.5" />
      <path d="M12 2.5v2.5M12 19v2.5M4.2 4.2l1.8 1.8M18 18l1.8 1.8M2.5 12H5M19 12h2.5M4.2 19.8L6 18M18 6l1.8-1.8" />
    </Icon>
  )
}

export function BoltIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M12.5 2.5 4 14h6l-1.5 7.5L20 10h-6l-1.5-7.5Z" strokeLinejoin="round" />
    </Icon>
  )
}

export function ShieldCheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M12 2.75 4.5 5.5v6c0 5 3.2 8.4 7.5 9.75 4.3-1.35 7.5-4.75 7.5-9.75v-6L12 2.75Z" />
      <path d="m9 12.25 2.2 2.2L15.5 10" />
    </Icon>
  )
}

export function PhoneOffIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M4 4.5c.4 3 1.4 5.9 3 8.5m3 3c2.6 1.6 5.5 2.6 8.5 3l1.5-3.3c.2-.5 0-1.1-.5-1.4l-3.4-1.9c-.4-.2-.9-.2-1.3.1l-1.3 1c-1.7-1-3.1-2.4-4.1-4.1l1-1.3c.3-.4.3-.9.1-1.3L8.6 4.9c-.3-.5-.9-.7-1.4-.5L4 5.9" />
      <path d="M3 3l18 18" />
    </Icon>
  )
}

export function ScaleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M12 3v18M7 21h10M4.5 7 8.5 7M15.5 7h4M4.5 7 2 12.5a2.5 2.5 0 0 0 5 0L4.5 7ZM19.5 7 17 12.5a2.5 2.5 0 0 0 5 0L19.5 7ZM12 3l-3.5 4M12 3l3.5 4" />
    </Icon>
  )
}

export function CheckCircleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <circle cx="12" cy="12" r="9.25" />
      <path d="m8 12.3 2.6 2.6L16.2 9" />
    </Icon>
  )
}

/** Pendant zu CheckCircleIcon für "Nein"-Kacheln. */
export function XCircleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <circle cx="12" cy="12" r="9.25" />
      <path d="m9 9 6 6m0-6-6 6" />
    </Icon>
  )
}

/** Wiederverwendet für alle "weiß nicht/unsicher/sonstiges/keine Präferenz"-Kacheln im Wizard. */
export function SearchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <circle cx="10.5" cy="10.5" r="6.5" />
      <path d="m20 20-4.8-4.8" />
    </Icon>
  )
}

export function HouseSolarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M3.5 11 12 4l8.5 7" />
      <path d="M5.5 9.8V20h13V9.8" />
      <path d="M9.5 20v-5h5v5" />
      <path d="m7.5 12 2-1.2m0 0 2-1.2m-2 1.2 2 1.2m-2-1.2v2.4" />
    </Icon>
  )
}

export function EuroIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M16 6.5a6.5 6.5 0 1 0 0 11" />
      <path d="M5.5 10h8.5M5.5 14h7.5" />
    </Icon>
  )
}

export function TargetIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <circle cx="12" cy="12" r="8.5" />
      <circle cx="12" cy="12" r="4.5" />
      <circle cx="12" cy="12" r="0.9" fill="currentColor" stroke="none" />
    </Icon>
  )
}

export function BugIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M9.5 4.5 8 3M14.5 4.5 16 3" />
      <rect x="7.5" y="8" width="9" height="10.5" rx="4.5" />
      <path d="M12 8V6" />
      <path d="M4 11h3.5M20 11h-3.5M4 14.5h3.5M20 14.5h-3.5M4.5 18.5 7.8 17M19.5 18.5 16.2 17" />
    </Icon>
  )
}

export function MailIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <rect x="3" y="5.5" width="18" height="13" rx="2" />
      <path d="m4 7 8 6 8-6" />
    </Icon>
  )
}

export function StarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="m12 3.3 2.7 5.6 6.1.9-4.4 4.3 1 6.1-5.4-2.9-5.4 2.9 1-6.1-4.4-4.3 6.1-.9L12 3.3Z" strokeLinejoin="round" />
    </Icon>
  )
}

/** Kleines Roofora-"Dach" (Haus-Silhouette: Giebeldach + Vorsprung über einem Baukörper) - ersetzt
 *  StarIcon als Bewertungs-Symbol in RatingDialog/PlatformRatingDialog (Nutzerwunsch: eigenes
 *  Markenzeichen statt generischer Sterne). Ein einzelner geschlossener Pfad wie bei StarIcon,
 *  damit `fill="currentColor"` (ausgewählt) vs. `fill="none"` (nicht ausgewählt) genauso
 *  funktioniert. */
export function RoofIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M12 3 21 11.5h-3V20H6v-8.5H3Z" strokeLinejoin="round" />
    </Icon>
  )
}

/** Brand mark, not an outline glyph like the rest of this file - filled to stay recognizable as
 *  the Facebook logo (see MarketingFooter's social link). */
export function FacebookIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M13.5 21v-8h2.7l.4-3.1h-3.1V8c0-.9.25-1.5 1.55-1.5H16.8V3.7C16.5 3.66 15.5 3.6 14.35 3.6c-2.4 0-4.05 1.47-4.05 4.15v2.15H7.6v3.1h2.7V21h3.2Z" />
    </svg>
  )
}

/** Instagram brand mark, filled like FacebookIcon so both social links inherit their context's
 *  foreground colour without needing icon-specific CSS. */
export function InstagramIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M7.8 2h8.4A5.8 5.8 0 0 1 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8A5.8 5.8 0 0 1 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2Zm-.2 2A3.6 3.6 0 0 0 4 7.6v8.8A3.6 3.6 0 0 0 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6A3.6 3.6 0 0 0 16.4 4H7.6Zm9.65 1.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" />
    </svg>
  )
}

export function HandshakeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="m2.5 11 3.8-3.3a2 2 0 0 1 2.6 0L11 9.5" />
      <path d="m21.5 11-3.8-3.3a2 2 0 0 0-2.6 0l-4 3.4a1.4 1.4 0 0 0 1.8 2.2l2.4-2" />
      <path d="M6.3 10.7 3 13.5 6.7 18l1.9-1.6" />
      <path d="m9 12.4 3 2.6a1.4 1.4 0 0 0 1.9-2.1M17.7 10.7 21 13.5 17.3 18l-3.8-3.2" />
    </Icon>
  )
}

/** Admin-Console Sidebar-Nav "Übersicht" (roofora-task-032-v2). */
export function GridIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <rect x="3.5" y="3.5" width="7.5" height="7.5" rx="1.5" />
      <rect x="13" y="3.5" width="7.5" height="7.5" rx="1.5" />
      <rect x="3.5" y="13" width="7.5" height="7.5" rx="1.5" />
      <rect x="13" y="13" width="7.5" height="7.5" rx="1.5" />
    </Icon>
  )
}

/** Admin-Console Sidebar-Nav "Kunden" (roofora-task-032-v2). */
export function UsersIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <circle cx="8.5" cy="8" r="3" />
      <path d="M3 19.5c0-3 2.5-5 5.5-5s5.5 2 5.5 5" />
      <circle cx="17" cy="9" r="2.4" />
      <path d="M15.3 14.8c2.3.2 4.2 1.9 4.2 4.7" />
    </Icon>
  )
}

/** Admin-Console Sidebar-Nav "Logs" (roofora-task-032-v2). */
export function ClipboardListIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <rect x="5" y="4.5" width="14" height="17" rx="2" />
      <path d="M9 4.5V3.8A1.8 1.8 0 0 1 10.8 2h2.4A1.8 1.8 0 0 1 15 3.8v.7" />
      <path d="M8.5 10.5h7M8.5 14h7M8.5 17.5h4.5" />
    </Icon>
  )
}

/** Admin-Console Sidebar-Nav "Tools" (roofora-task-032-v2). */
export function WrenchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M14.7 6.3a4.3 4.3 0 0 0-5.9 4.9L3.5 16.5a1.9 1.9 0 0 0 2.7 2.7l5.3-5.3a4.3 4.3 0 0 0 4.9-5.9l-2.9 2.9-2-2 2.9-2.9Z" />
    </Icon>
  )
}
